import { post } from './common.js';

export function initialTranscodeAdmin(attachment_id, update_api=true) {
    return post(`/attachments/${attachment_id}/initial_transcode/`, {"update_api": update_api}, 'admin');
}
